export type ColorMode = 'system' | 'light' | 'dark';

export default class UserSettings {
  constructor(
    public developerMode: boolean = false,
    public confirmQuantity: boolean = false,
    public showLotVisual: boolean = false,
    public showAuditVisual: boolean = false,
    public showBarcode: boolean = false,
    public cultureName: string | undefined = "en",
    public lastUsedSiteId: number = 0,
    public colorMode: ColorMode = 'system',
  ) {
  }
}
